<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header">
                            Search Form
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">
                                        <v-col lg="3" md="3" cols="12">
                                            <v-date-input
                                            label="From Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi mdi-calendar-month"
                                            single-line
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="from_date.value.value"
                                            :error-messages="from_date.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            ></v-date-input>
                                        </v-col>

                                        <v-col lg="3" md="3" cols="12">
                                            <v-date-input
                                                label="To Date"
                                                density="compact"
                                                single-line
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                            </v-col>

                                        <!-- <v-col lg="3" md="3" cols="12">
                                            <v-autocomplete
                                                label="Ware House"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="warehouse_id.value.value"
                                                :items="getWarehouseList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="warehouse_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-autocomplete>
                                        </v-col> -->
                                        
                                        <v-col lg="2" md="2" cols="12">
                                            <v-btn
                                            class="bg-brand w-15"
                                            type="submit"
                                            ref="searchButton">
                                                Search
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Sales Invoice Delivery Records
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                    <v-col md="4" cols="12">
                                        <v-text-field
                                        v-model="search"
                                        append-inner-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details
                                        density="compact"
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        class="pl-2"
                                        clearable
                                        ></v-text-field>
                                    </v-col>

                                    <v-col md="4" cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                            >
                                                <!-- <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn> -->
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                    <v-col md="4" cols="12">
                                        <div class="text-right pr-2">
                                            <v-btn
                                            v-if="$insertAccess($route.fullPath)"
                                            @click="goTo('/inventory/sale-delivery')"
                                            color="primary"
                                            variant="tonal"
                                            prepend-icon="mdi mdi-plus"
                                            rounded="xl"
                                            >
                                                Create Sales Delivery
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                                
                                <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    hover
                                    density="compact"
                                    show-expand
                                    item-value="id"
                                    class="mt-3"
                                >
                                <!-- SL -->
                                <template v-slot:item.index="{ index }">
                                    {{ index + 1 }}
                                </template>

                                <!-- Customer -->
                                <template v-slot:item.customer="{ item }">
                                    {{ item?.customer?.company_owner_name
                                    ? item.customer.company_owner_name
                                    : item?.customer?.customer_name }}
                                </template>

                                <!-- Supplier -->
                                <template v-slot:item.supplier="{ item }">
                                    {{ item?.supplier?.company_owner_name
                                    ? item.supplier.company_owner_name
                                    : item?.supplier?.customer_name }}
                                </template>

                                <!-- Exchange Rate -->
                                <template v-slot:item.exchange_rate="{ item }">
                                    {{ item?.exchange_rate?.currency?.symbol }}
                                    {{ item?.exchange_rate?.currency?.code }}
                                </template>

                                <!-- Status -->
                                <template v-slot:item.status="{ item }">
                                    <v-chip
                                    :color="statusMap[item.status]?.color || 'grey'"
                                    size="small"
                                    class="text-capitalize"
                                    >
                                    {{ statusMap[item.status]?.label || "Unknown" }}
                                    </v-chip>
                                </template>

                                <!-- Actions -->
                                <template v-slot:item.actions="{ item }">
                                    <v-icon
                                    class="me-2"
                                    color="primary"
                                    @click="editItem(item)"
                                    v-if="$updateAccess($route.fullPath) && item.lock === 0"
                                    >
                                    mdi-pencil-outline
                                    </v-icon>

                                    <v-icon
                                    class="me-2"
                                    color="primary"
                                    @click="viewSaleDeliveryInvoice(item)"
                                    v-if="$updateAccess($route.fullPath) && item.status == 1"
                                    title="View Invoice"
                                    >
                                    mdi-file-document-outline
                                    </v-icon>


                                </template>

                                <!-- EXPANDED ROW -->
                                <template v-slot:expanded-row="{ columns, item }">
                                    <tr>
                                    <td :colspan="columns.length" class="pa-3">

                                        <v-expand-transition>
                                        <v-card
                                            elevation="0"
                                            rounded="lg"
                                            class="pa-3 bg-grey-lighten-5"
                                        >
                                            <v-table density="compact" hover>
                                            <thead>
                                                <tr class="bg-grey-lighten-3 text-subtitle-2">
                                                    <th class="text-center" style="width:60px">SL</th>
                                                    <th>Order No</th>
                                                    <th>Challan No</th>
                                                    <th>Shop Name</th>
                                                    <th>S. Company Name</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr
                                                    v-for="(saleOrder, index) in item.sales_orders"
                                                    :key="saleOrder.id || index"
                                                    >
                                                    <td class="text-center">{{ index + 1 }}</td>
                                                    <td>{{ saleOrder?.sale_order?.code }}</td>
                                                    <td>{{ saleOrder?.sale_order?.chalan_no || '-' }}</td>
                                                    <td>{{ saleOrder?.sale_order?.shop_name || '-' }}</td>
                                                    <td>{{ saleOrder?.sale_order?.shipper_company_name || '-' }}</td>
                                                    <td>
                                                        <v-icon  color="primary" @click="generateSaleInvoice(item, saleOrder)" title="Generate Sale Invoice">
                                                            mdi-file-plus-outline
                                                        </v-icon>
                                                        &nbsp;
                                                        &nbsp;
                                                        <v-icon  color="primary" @click="saleInvoiceDeliveryOrder(saleOrder)" title="Sale Order Delivery Invoice">
                                                            mdi-file-document-outline
                                                        </v-icon>
                                                    </td>
                                                </tr>

                                                <!-- Empty State -->
                                                <tr v-if="!item.sales_orders?.length">
                                                <td colspan="5" class="text-center text-grey pa-4">
                                                    No Sale Orders Found
                                                </td>
                                                </tr>
                                            </tbody>
                                            </v-table>
                                        </v-card>
                                        </v-expand-transition>

                                    </td>
                                    </tr>
                                </template>
                                </v-data-table>

                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { prefix } from "@/store/api";
import axios from "axios";
import statusMap from "@/utils/statusMap";

export default {
    components: {},
    data: () => ({
        itemsPerPage: 10,
        panel: [0],
        loading: false,
        search: "",
        dialog: false,
        data: {},
        statusMap,
        headers: [
            { title: "#SL", align: "center", key: "index", width: "15px", sortable: false },
            { title: "Delivery No", key: "code", align: "center", sortable: false },
            // { title: "Order No", key: "order_master.code", align: "center", width: "100px", sortable: false },
            { title: "Conainer No", key: "container_no", align: "center", width: "100px", sortable: false },
            { title: "Total Item", key: "total_item", align: "center", width: "80px", sortable: false },
            { title: "Delivery Date", key: "delivery_date", align: "center", width: "120px", sortable: false },
            // { title: "Buyer", key: "customer", align: "center" , width: "150px", sortable: false },
            // { title: "Shipper", key: "supplier", align: "center" , width: "150px", sortable: false },
            { title: "From Port", key: "from_port.name", align: "center" , width: "150px", sortable: false },
            { title: "To Port", key: "to_port.name", align: "center" , width: "150px", sortable: false },
            { title: "Currency", align: "center", key: "exchange_rate", sortable: true },
            { title: "Status", align: "center", key: "status", sortable: true },
            { title: "Actions", align: "center", key: "actions", sortable: false, width: "110px",},
        ],
    }),
    watch: {},
    created() {
        if (this.$store.getters.getHrmDepartmentList.length === 0) {
            this.$store.dispatch("getHrmDepartmentList");
        }
        if (this.$store.getters.getWarehouseList.length === 0) {
            this.$store.dispatch("getWarehouseList");
        }
    },
    computed: {
        getSchema() {
            return this.$store.getters.getInvSalesInvoiceDeliveryList;
        },
        getHrmDepartmentList() {
            return this.$store.getters.getHrmDepartmentList;
        },
        getWarehouseList() {
            return this.$store.getters.getWarehouseList;
        },
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                // date_range: yup.date().required().label('Requisition Date'),
                // department_id: yup.number().positive().integer().nullable().label('Department Name'),
                // warehouse_id: yup.number().positive().integer().nullable().label('Warehouse Name'),
            }),
        });

        const department_id = useField("department_id");
        const warehouse_id = useField("warehouse_id");
        const from_date = useField("from_date");
        const to_date = useField("to_date");
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();

        const submit = handleSubmit((values) => {
            loading.value = true;
            values.from_date = formattedDate(from_date.value.value);
            values.to_date = formattedDate(to_date.value.value);
            store
                .dispatch("getInvSalesInvoiceDeliveryList", values)
                .then((response) => {
                    loading.value = false;
                })
                .catch((error) => {
                    toast.error(error.response.data.message);
                });
        });

        return {
            submit,
            from_date,
            to_date,
            errorMessages,
            department_id,
            warehouse_id,
            loading,
        };
    },
    methods: {
        formattedDate,
        goTo(val) {
            this.$router.push({ path: val }).catch((err) => {});
        },
        async generateSaleInvoice(delivery, item) {
            if (confirm('Are you sure you want to generate invoice of this delivery?')) {
                let cart = [];

                (item.details || []).forEach((detail) => {
                    cart.push({
                        product_id: detail?.product_id,
                        sale_order_detail_id: detail?.sale_order_detail?.id,
                        order_qty: detail?.sale_order_detail?.qty,
                        qty: detail?.qty,
                        already_invoiced_qty: detail?.qty,
                        remaining_qty: 0,
                        sale_rate: detail?.sale_order_detail?.rate,
                        total: (detail?.qty || 0) * (detail?.sale_order_detail?.rate || 0),
                    });
                });

                const saleOrderData = {
                    sale_delivery_id: item?.delivery_master_id,
                    sale_order_id: item?.sale_order_master_id,
                    sale_delivery_order_id: item?.id,
                    sale_invoice_date: this.formattedDate(new Date()),
                    customer_id: item?.sale_order?.customer_id,
                    supplier_id: item?.sale_order?.supplier_id,
                    from_port_id: item?.sale_order?.from_port_id,
                    to_port_id: item?.sale_order?.to_port_id,
                    warehouse_id: item?.sale_order?.warehouse_id,
                    payment_method: '',
                    rate_id: item?.sale_order?.rate_id,
                    currency_rate: item?.sale_order?.currency_rate,
                    container_no: delivery?.container_no,
                    mbl_no: delivery?.mbl_no,
                    hbl_no: delivery?.hbl_no,
                    mbl_date: delivery?.mbl_date,
                    discount_amount: item?.sale_order?.discount_amount,
                    discount_method: item?.sale_order?.discount_method,
                    discount_value: item?.sale_order?.discount_value,
                    tax_method: item?.sale_order?.tax_method,
                    tax_type: item?.sale_order?.tax_type,
                    tax_amount: item?.sale_order?.tax_amount,
                    tax_value: item?.sale_order?.tax_value,
                    vat_method: item?.sale_order?.vat_method,
                    vat_type: item?.sale_order?.vat_type,
                    vat_amount: item?.sale_order?.vat_amount,
                    vat_value: item?.sale_order?.vat_value,
                    sub_total: item?.sale_order?.sub_total,
                    sales_by: item?.sale_order?.sales_by,
                    status: '1',
                    total: item?.sale_order?.total,
                    paid: item?.sale_order?.paid,
                    due: item?.sale_order?.due,
                    cart: cart,
                };
                await axios.post(prefix + 'sales/save-update-sls-sale-invoice', saleOrderData)
                    .then(async (response) => {
                    const data = response.data;
                    if(data.success) {
                        toast.success(response.data.message, {
                            timeout: 3000,
                        });
                        this.$store.dispatch("getInvSalesInvoiceDeliveryList");
                        this.$router.push({name: "sale-invoice-record"});
                    }
                }).catch((error) => {
                    console.error("Error fetching requisitions:", error);
                    if (error.response && error.response.data && error.response.data.errors) {
                        const errors = error.response.data.errors;
                        const messages = Object.values(errors).flat().join('\n');
                        toast.error(messages);
                    } else {
                        toast.error(error.response?.data?.message || 'Something went wrong');
                    }
                });
            } 
        },
        saleInvoiceDeliveryOrder(item){
            this.$router.push({
                name: "sale-invoice-delivery-order",
                params: { id: item.id },
            });
        },
        editItem(item) {
            this.$router.push({
                name: "sale-delivery",
                query: { id: item.id },
            });
        },

        viewSaleDeliveryInvoice(item) {
            this.$router.push({
                name: "view-sale-delivery-invoice",
                query: { id: item.id },
            });
        },

        exportToPDF() {
            let serialNumber = 1;
            const columns = [ "#SL", "Code", "Department", "Warehouse", "Amount", "Approval Status", "Status" ];
            const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.department.name, item.warehouse.name, item.amount, item.approved_ind === 1 ? "YES" : "NO", item.status == 1 ? "Active" : "Inactive" ]);

            this.$exportTableToPDF( columns, rows, "Inventary Requisition List", "inventory_requisition_list_" + this.$fileDate(), "landscape" );
        },

        exportToExcel() {
            var data = [[ "#SL", "Code", "Department", "Warehouse", "Amount", "Approval Status", "Status" ]];

            var serialNumber = 1;
            this.getSchema.forEach((item) => {
                data.push([ serialNumber++, item.code, item.department.name, item.warehouse.name, item.amount, item.approved_ind === 1 ? "YES" : "NO", item.status == 1 ? "Active" : "Inactive" ]);
            });
            this.$exportTableToExcel(
                data,
                "inventory_requisition_list_" + this.$fileDate()
            );
        },
        
        exportToCSV() {
            var data = [["#SL","Code","Department","Warehouse","Amount","Approval Status","Status"],];
            var serialNumber = 1;
            this.getSchema.forEach((item) => {
                data.push([ serialNumber++, item.code, item.department.name, item.warehouse.name, item.amount, item.approved_ind === 1 ? "YES" : "NO", item.status == 1 ? "Active" : "Inactive" ]);
            });

            this.$exportTableToCSV(
                data,
                "inventory_requisition_list_" + this.$fileDate()
            );
        },
    },
    mounted() {
        this.from_date.value.value = new Date(new Date().setDate(new Date().getDate() - 7));
        this.to_date.value.value = new Date();
        this.$nextTick(() => {
            this.$refs.searchButton.$el.click();
        });   
    },
};
</script>
